import React from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import { useQuery } from '@apollo/client';
import { GET_FLOC_DETAILS } from '../../../graph-queries/materials/floc';
import { useParsedSearchParams } from '../../../lib/util';
import classes from './FlocPage.module.scss';
import MediaUpload from '../../organisms/MediaUpload/MediaUpload';
import MediaGallaryMini from '../../organisms/MediaGallaryMini/MediaGallaryMini';

const FlocPage: React.FC = () => {
  const [asset] = useParsedSearchParams('asset');
  const [floc] = useParsedSearchParams('floc');
  const { data, loading } = useQuery(GET_FLOC_DETAILS, { variables: { asset, floc } });

  const flocDesc = data?.flocDetails.flocDetails || '';

  if (!data?.flocDetails.flocExists) {
    return <></>;
  }

  return (
    <section style={{ backgroundColor: '#f2f2f2', padding: '32px 0' }}>
      <Container className={`g-2 d-flex gap-6 flex-column ${classes.root}`}>
        <Row xs={1}>
          <Col>
            <Card className="card-border" outline>
              <CardHeader className={classes.flocDescHeader}>
                <div className={classes.flocDescDetails} title={flocDesc}>
                  <div className={classes.flocDesc}>{flocDesc}</div>
                </div>
                {/* <Button level="tertiary">View FLOC Hierarchy</Button> */}
              </CardHeader>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeader className={classes.media}>Related Media</CardHeader>
              <CardBody>
                <MediaUpload floc={floc} />
                <MediaGallaryMini floc={floc} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FlocPage;
